import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-global-search-input',
  templateUrl: './global-search-input.component.html',
  styleUrls: ['./global-search-input.component.scss']
})
export class GlobalSearchInputComponent implements OnInit, OnDestroy {
  searchText: string;
  @Output() search: EventEmitter<string> = new EventEmitter<string>();

  private queryParamsSubscription: Subscription;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.queryParamsSubscription = this.activatedRoute.queryParamMap.subscribe((queryParams) => {
      this.searchText = queryParams.get('q');
    });
  }

  ngOnDestroy() {
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
  }

  triggerSearch() {
    this.router.navigate([`/search`], {queryParams: {q: this.searchText}});
    this.search.next(this.searchText);
  }
}
